/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { SelectPricingRuleRequestDTOToJSON, UserMarketplacePricingRuleResponseDTOFromJSON, } from '../models/index';
/**
 *
 */
export class UserMarketplacePricingRuleControllerApi extends runtime.BaseAPI {
    /**
     */
    async getRulesRaw(requestParameters, initOverrides) {
        if (requestParameters['marketplace'] == null) {
            throw new runtime.RequiredError('marketplace', 'Required parameter "marketplace" was null or undefined when calling getRules().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/marketplace/{marketplace}/pricing-rules`;
        urlPath = urlPath.replace(`{${"marketplace"}}`, encodeURIComponent(String(requestParameters['marketplace'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserMarketplacePricingRuleResponseDTOFromJSON));
    }
    /**
     */
    async getRules(requestParameters, initOverrides) {
        const response = await this.getRulesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async setSelectedRaw(requestParameters, initOverrides) {
        if (requestParameters['marketplace'] == null) {
            throw new runtime.RequiredError('marketplace', 'Required parameter "marketplace" was null or undefined when calling setSelected().');
        }
        if (requestParameters['selectPricingRuleRequestDTO'] == null) {
            throw new runtime.RequiredError('selectPricingRuleRequestDTO', 'Required parameter "selectPricingRuleRequestDTO" was null or undefined when calling setSelected().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/marketplace/{marketplace}/pricing-rules/select`;
        urlPath = urlPath.replace(`{${"marketplace"}}`, encodeURIComponent(String(requestParameters['marketplace'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SelectPricingRuleRequestDTOToJSON(requestParameters['selectPricingRuleRequestDTO']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async setSelected(requestParameters, initOverrides) {
        await this.setSelectedRaw(requestParameters, initOverrides);
    }
    /**
     */
    async syncRulesRaw(requestParameters, initOverrides) {
        if (requestParameters['marketplace'] == null) {
            throw new runtime.RequiredError('marketplace', 'Required parameter "marketplace" was null or undefined when calling syncRules().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/marketplace/{marketplace}/pricing-rules/syncRules`;
        urlPath = urlPath.replace(`{${"marketplace"}}`, encodeURIComponent(String(requestParameters['marketplace'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserMarketplacePricingRuleResponseDTOFromJSON));
    }
    /**
     */
    async syncRules(requestParameters, initOverrides) {
        const response = await this.syncRulesRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const GetRulesMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const SetSelectedMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const SyncRulesMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
